import { render, staticRenderFns } from "./Consistenze.vue?vue&type=template&id=b0a6c8ce&scoped=true&"
import script from "./Consistenze.vue?vue&type=script&lang=js&"
export * from "./Consistenze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a6c8ce",
  null
  
)

export default component.exports